import { ThemeOptions } from "@mui/material";
import {
  commonBorderRadius,
  generateDefaultGJTypography,
  generateErrorWarnInfoColors,
  MuiButton,
  MuiChip,
  MuiFilledInput,
  styleRootCommonAppBar
} from "./util/theme-generator-util";

export const phagenbeckFontFamilyRegular = "Hagenbeck Neue";

export const phagenbeckThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: commonBorderRadius
  },
  palette: {
    primary: {
      main: "#365648"
    },
    secondary: {
      main: "#D83231"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#F3EEE6",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#365648",
      secondary: "#D83231"
    },
    action: {
      disabledOpacity: 0
    }
  },
  typography: generateDefaultGJTypography(phagenbeckFontFamilyRegular)
};
